function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "url(#paint0_linear)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.2793 23.2354H19.9999H27.7205C27.7205 26.2809 25.9922 28.7501 23.8602 28.7501C21.7282 28.7501 19.9999 26.2809 19.9999 23.2354C19.9999 26.2809 18.2716 28.7501 16.1396 28.7501C14.0076 28.7501 12.2793 26.2809 12.2793 23.2354Z",
  fill: "white"
});

var _ref4 =
/*#__PURE__*/
React.createElement("mask", {
  id: "path-3-inside-1",
  fill: "white"
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.5148 10H14.4854L12.2795 18.8235H27.7207L25.5148 10ZM31.0296 18.8236H8.9707V21.0295H31.0296V18.8236Z"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.4854 10V8.5H13.3142L13.0302 9.6362L14.4854 10ZM25.5148 10L26.9701 9.6362L26.686 8.5H25.5148V10ZM12.2795 18.8235L10.8243 18.4597L10.3584 20.3235H12.2795V18.8235ZM27.7207 18.8235V20.3235H29.6419L29.1759 18.4597L27.7207 18.8235ZM8.9707 18.8236V17.3236H7.4707V18.8236H8.9707ZM31.0296 18.8236H32.5296V17.3236H31.0296V18.8236ZM8.9707 21.0295H7.4707V22.5295H8.9707V21.0295ZM31.0296 21.0295V22.5295H32.5296V21.0295H31.0296ZM14.4854 11.5H25.5148V8.5H14.4854V11.5ZM13.7347 19.1874L15.9406 10.3638L13.0302 9.6362L10.8243 18.4597L13.7347 19.1874ZM27.7207 17.3235H12.2795V20.3235H27.7207V17.3235ZM24.0596 10.3638L26.2655 19.1874L29.1759 18.4597L26.9701 9.6362L24.0596 10.3638ZM8.9707 20.3236H31.0296V17.3236H8.9707V20.3236ZM10.4707 21.0295V18.8236H7.4707V21.0295H10.4707ZM31.0296 19.5295H8.9707V22.5295H31.0296V19.5295ZM29.5296 18.8236V21.0295H32.5296V18.8236H29.5296Z",
  fill: "white",
  mask: "url(#path-3-inside-1)"
});

var _ref6 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: -9.83407e-7,
  y1: 40,
  x2: 43.3889,
  y2: 4.09535,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#21A6C4"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#39DEB7"
})));

var SvgInsightIcon = function SvgInsightIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInsightIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/insight-icon.c5b9c356.svg";
export { ForwardRef as ReactComponent };